import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { isDevMode } from "@utils/test-modes";
import authStore from "@utils/auth-store";
import { AllCommentArgsType, AllCommentsResponseType } from './types/commentsSystemTypes';

const BASE_API_URL = 'comments';

const getUrl = (
  type: 'all',
) => {
  const baseUrl = `${BASE_API_URL}/`;
  switch (type) {
    case 'all':
      return baseUrl;
    default:
      return '';
  }
};

export const commentsSystemApi = createApi({
  reducerPath: 'commentSystemApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `${
      isDevMode ? process.env.NEXT_PUBLIC_STAGING_URL : ''
    }topics/api/v1/`,
    prepareHeaders: (headers) => {
      const jwt = authStore.get().jwt;
      if (jwt) {
        headers.set('X-User-Token', jwt);
      }
      return headers;
    }
  }),
  tagTypes: ['GetAllComments'],
  endpoints: (builder) => ({
    fetchAllComments: builder.query<AllCommentsResponseType, AllCommentArgsType>({
      query: (args) => ({
        method: 'GET',
        url: getUrl('all'),
        params: {
          record_type: args.recordType,
          record_slug: args.slug,
          "filters[page][limit]": args.filters.limit,
          "filters[page][current_page]": args.filters.current_page,
        }
      }),
      providesTags: ['GetAllComments'],
    }),
  })
})

export const {
  useFetchAllCommentsQuery,
  useLazyFetchAllCommentsQuery,
} = commentsSystemApi;

export type CommentsSystemApiReducer = typeof commentsSystemApi.reducer;
